import styled from 'styled-components';
import { MetaRow, Panel, SectionLabel } from '@/ui';
import type { Community } from '@/core/models/community';

const P = styled.p`margin: 0 0 8px; font-family: ${({ theme }) => theme.font.body}; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textMuted};`;
const Meta = styled.p`margin: 0; font-family: ${({ theme }) => theme.font.mono}; font-size: ${({ theme }) => theme.fontSize.xs}; color: ${({ theme }) => theme.color.textMuted};`;

export function AboutCommunityPanel({ community }: { community: Community }) {
  return (
    <Panel>
      <SectionLabel as="h2">About this community</SectionLabel>
      <P>{community.description}</P>
      <Meta>
        <MetaRow>
          <span>{community.members}</span>
          <span>{community.postsCount} posts</span>
          <span>{community.online} online</span>
        </MetaRow>
      </Meta>
    </Panel>
  );
}
